import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import Select from '../../../common/forms/select/Select';
import { DRIVER_STATUS_TYPE } from '../../../../config/constants';

export const DRIVER_TASK_SUMMARY_BASE_FORM = 'DriverTaskSummaryBaseForm';

const DriverTaskSummaryBaseForm = () => (
  <Form onSubmit={(event) => event.preventDefault()}>
    <FormGroup row>
      <FormItem label="Base">
        <Field
          name="homeBaseLocation"
          component={LocationSelect}
          placeholder="Bases"
          forHomeBase
          isMulti
        />
      </FormItem>
      <FormItem label="Estado">
        <Field
          name="driverStatusType"
          component={Select}
          options={Object.values(DRIVER_STATUS_TYPE)}
          placeholder="Estado"
          isMulti
        />
      </FormItem>
    </FormGroup>
  </Form>
);

export default reduxForm({
  form: DRIVER_TASK_SUMMARY_BASE_FORM,
})(DriverTaskSummaryBaseForm);